var $ = require("jquery");
import { gsap, ScrollTrigger } from "./globals.js";

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.matchMedia({
  "(min-width: 1024px)": function () {
    function applyNegativeMarginToTeamCards() {
      document.querySelectorAll(".team-card").forEach((card) => {
        const bio = card.querySelector(".team-card__bio");
        if (bio) {
          const bioHeight = bio.offsetHeight;
          card.style.marginBottom = `-${bioHeight + 10}px`;
        }
      });
    }

    // Run on DOM ready
    document.addEventListener("DOMContentLoaded", applyNegativeMarginToTeamCards);

    document.querySelectorAll(".team-card").forEach((card) => {
      const imgWrapper = card.querySelector(".team-card__img");
      const bio = card.querySelector(".team-card__bio");

      // Only proceed if bio exists
      if (!bio) return;

      const linkedin = card.querySelector(".team-card__linkedin");

      // Set initial states
      gsap.set(bio, { autoAlpha: 0, y: 10 });
      if (linkedin) gsap.set(linkedin, { autoAlpha: 0, y: 10 });
      gsap.set(imgWrapper, { clearProps: "height" });

      let originalHeight;

      card.addEventListener("mouseenter", () => {
        if (!originalHeight) {
          originalHeight = imgWrapper.offsetHeight;
        }

        // Show bio offscreen to measure height
        gsap.set(bio, { autoAlpha: 1, position: "absolute", visibility: "hidden" });
        const bioHeight = bio.offsetHeight + 10;
        gsap.set(bio, { autoAlpha: 0, position: "", visibility: "" });

        const newHeight = originalHeight - bioHeight;

        // Animate image shrink
        gsap.to(imgWrapper, {
          height: newHeight,
          duration: 0.4,
          ease: "power2.out",
        });

        // Animate bio in
        gsap.to(bio, {
          autoAlpha: 1,
          y: 0,
          duration: 0.4,
          delay: 0.1,
          ease: "power2.out",
        });

        // Animate LinkedIn in if it exists
        if (linkedin) {
          gsap.to(linkedin, {
            autoAlpha: 1,
            y: 0,
            duration: 0.4,
            delay: 0.2,
            ease: "power2.out",
          });
        }
      });

      card.addEventListener("mouseleave", () => {
        // Reset image height
        gsap.to(imgWrapper, {
          height: originalHeight,
          duration: 0.4,
          ease: "power2.inOut",
        });

        // Animate bio out
        gsap.to(bio, {
          autoAlpha: 0,
          y: 10,
          duration: 0.3,
          ease: "power2.in",
        });

        // Animate LinkedIn out if it exists
        if (linkedin) {
          gsap.to(linkedin, {
            autoAlpha: 0,
            y: 10,
            duration: 0.3,
            ease: "power2.in",
          });
        }
      });
    });
  }
});
